//Global keys
let locales = {
  ok: "Ok",
  close: "Close",
  add: "Add",
  cancel: "Cancel",
  okay: "Okay",
  print: "Print",
  continue: "Continue",
  back: "Back",
  save: "Save",
  new: "New",
  required_field: "Required field",
  clearAll: "Clear All",
  clear: "Clear",
  selectAnOption: "Please select an option",
  select: "Select",
  files: "Files",
  remove_all: "Remove all",
  choose: "Choose",
  noAvailableTags: "No available tags",
  lan_english: "English",
  lan_spanish: "Spanish",

  all: "All",
  days: "Days",
  day: "Day",
  Days: "Days",
  Day: "Day",
  miles: "Miles",
  kilometers: "Kilometers",
  feet: "Feet",
  hours: "Hours",
  hour: "Hour",
  Hours: "Hours",
  Hour: "Hour",
  min: "min",
  mins: "Mins",
  seconds: "Seconds",
  months: "Months",
  month: "Month",
  Months: "Months",
  Month: "Month",
  engineHours: "Engine Hours",
  odometer: "Odometer",
  select_date: "Select date",
  select_time: "Select time",
  etalink_eta: "Estimated Time of Arrival (ETA)",
  landmarks: "Landmarks",
  geofences: "Geofences",

  Monday: "M",
  Tuesday: "T",
  Wednesday: "W",
  Thursday: "Th",
  Friday: "F",
  Saturday: "S",
  Sunday: "Su",

  dtc_codes: "DTC Codes",
  success: "Success",

  min: "Min",
  max: "Max",
  characters: "Characters",

  pending: "Pending",
  due: "Due",
  dueSoon: "Due Soon",
  dueNow: "Due Now",
  pastDue: "Past Due",
  scheduled: "Scheduled",
  schedule: "Schedule",
  reminder: "Reminder",
  next: "Next",
  done: "Done",
  edit: "Edit",
  complete: "Complete",
  update: "Update",
  delete: "Delete",
  DELETE: "DELETE",
  ago: "ago",
  // "1010": "There is already a record with the name entered",
  duplicated_name: "There is already a record with the name entered",
  invalid_params: "Invalid Params",
  invalid_params_ftp: "Error connecting to FTP: Invalid Params",
  exist_ftp:
    "The FTP cannot be deleted until those schedules be deleted or updated to use another FTP Server or delivery mode.",
  attachmentsFilesAllowed:
    "jpg, png, gif, txt, doc, docx, pdf, csv, xls, xlsx. 4MB",

  context_menu_table: "Table Columns",
  context_menu_show_all: "Show All",
  visibility_validation_title: "Wait!",
  visibility_validation_message: "you must have at least one column visible!",

  collapse: "Collapse",
  expand: "Expand",

  time_today_reported: "Reported Today",
  time_today_not_reported: "Not Reported Today",
  time_not_reported_seven_days: "Not Reported in 7 Days",
  time_not_reported_thirty_days: "Not Reported in 30 Days",

  //select menu
  select_all: "Select all",
  must_select_at_least_one_option: "Must select at least one option",

  search: "Search",
  noOptions: "No options",
  prev: "Previous",
  nextp: "Next",
  perPage: "per page",
  noMoreItems: "There are no more items.",
  fetching_more_list_items: "loading more list items...",

  //table Pagination
  pag_prev: "Previous",
  pag_next: "Next",
  pag_per_page: "per page",

  //table toolbar
  table_search: "Search",
  table_export_csv: "Export CSV",
  table_export_pdf: "Export PDF",
  table_filter: "Filter",
  table_add: "Add",
  table_delete: "Delete",
  table_refresh: "Refresh",
  table_export: "Export",
  table_visibility: "Visibility",
  table_all: "all",
  table_share: "Share",

  //input search
  Search: "Search",
  Cancel: "Cancel",
  Apply: "Apply",

  yes: "Yes",
  no: "No",

  // Dates
  dates: "Dates",
  date_today: "Today",
  days_away: "Days away",
  days_ago: "Days ago",
  date_current: "Current",
  date_yesterday: "Yesterday",
  date_this_week: "This Week",
  date_last_week: "Last Week",
  date_this_quarter: "This Quarter",
  date_last_quarter: "Last Quarter",
  date_custom: "Custom",
  date_this_month: "This Month",
  date_last_month: "Last Month",
  date_last_24hours: "Last 24 Hours",
  date_last_today: "Today",
  date_last_yesterday: "Yesterday",
  date_last_7days: "Last 7 Days",
  date_last_15days: "Last 15 Days",
  date_last_30days: "Last 30 Days",
  date_last_90days: "Last 90 Days",
  date_last_3months: "Last 3 Months",
  date_this_nextMonth: "Next Month",
  date_next_tomorrow: "Tomorrow",
  date_next_7days: "Next 7 Days",
  date_next_15days: "Next 15 Days",
  date_next_30days: "Next 30 Days",
  date_next_90days: "Next 90 Days",
  //for interval pill
  due_every: "Due every",
  reminder_at: "Remind at",
  pastDue_at: "Past due at",
  next_in: "Next in",

  //for dates
  at_time: "at",
  dateAndTime: "Date & Time",
  start: "Start",
  end: "End",
  set: "Set",

  //collapse button select menu
  show_all: "Show all",
  show_less: "Show less",
  collapse_to_ten: "Collapse to ten",

  menu_dashboard: "Dashboard",
  menu_fleet: "Status", //Renamed from "Fleet" temporary
  menu_vehicleStatus: "Vehicle Status",
  menu_map: "Maps",
  menu_realtimeMaps: "Maps",
  menu_reports: "Reports",
  menu_video: "Video",
  menu_delete: "Delete",
  menu_add: "Add",
  menu_manage: "Manage",
  menu_behavior: "Behavior",
  menu_maintenance: "Maintenance",
  menu_fieldSync: "FieldSync",
  menu_routes: "Routes",
  menu_MDT: "MDT",
  menu_FSM: "FSM",
  menu_media: "Media",
  menu_account: "Account",
  menu_preferences: "Preferences",
  menu_contacts: "Contacts",
  menu_help: "Help Center",
  menu_marketplace: "Marketplace",
  menu_driverStatus: "Driver Status",
  menu_advaceRouting: "Advance Routing",
  menu_customers: "Customers",
  menu_rfid: "RFID",
  menu_promiles: "Promiles",
  menu_zonar_eld: "Zonar Logs",
  menu_zonar_zpass: "Z Pass",
  menu_apollo_eld: "Apollo ELD",
  menu_fleet_io: "Fleetio",
  menu_car_iq: "Car IQ Pay",
  menu_eldfleet_eld: "ELDFleet (Legacy)",
  menu_evir: "EVIR",
  menu_evir_px: "EVIR",
  menu_evir_ib: "Inspection Builder",
  menu_inspection_builder: "Inspection Builder",
  menu_defect_list: "Defect List",
  menu_elogs: "Elogs",
  menu_loginHistory: "Login History",
  menu_accountInformation: "Account Information",
  menu_users: "Users",
  menu_feedback: "Feedback",
  menu_settings: "Settings",
  menu_apiKeys: "API",
  menu_tags: "Tags",
  menu_role: "Roles",
  menu_apps: "Apps",
  menu_dataExport: "Data Exports",
  menu_evirSettings: "EVIR Settings",
  settings_title: "EVIR Settings",
  menu_dynamic_forms: "Forms",
  menu_billingPortal: "Billing Portal",
  menu_workOrders: "Work Orders",
  menu_driverPerformance: "Driver Performance",

  // Iframes Monarch
  menu_netradyne_cams: "Netradyne Cams",
  menu_coach_sso: "Coaching",
  menu_monarch_driveri: "Driver I Cameras",
  menu_monarch_eld: "ELD Premium",
  menu_monarch_classic: "Classic Platform",
  menu_monarch_ditat: "DITAT TMS",
  menu_monarch_intangles: "Intangles",
  menu_xbiplus: "Business Intelligence",

  from: "from",
  to: "to",

  FROM: "from",
  TO: "to",

  error: "Error",
  information: "Information",
  errorMessage: "An error occurred, please try again.",
  notAvailable: "N/A",

  download: "Download",
  addFavorites: "Add to favorites",
  removeFavorites: "Remove from favorites",
  favorites: "Favorites",
  noItemsFound: "No matches found.",

  unassigned: "Unassigned",

  excellent: "Excellent",
  fair: "Fair",
  good: "Good",
  poor: "Poor",
  unknown: "Unknown",
  offline: "Offline",
  parking: "Parking",
  driving: "Driving",
  idling: "Idling",
  stopped: "Stopped",
  av_clips: "Av Clips",
  no_data: "No Data",
  no_video_av: "No Video Available",
  others: "Other",
  second_clip: "Seconds Clip",

  low: "Low",
  medium: "Medium",
  high: "High",

  at: "at",

  show: "Show",
  expandAll: "Expand All",
  hide: "Hide",
  documentation: "Documentation",
  draw: "Draw Control",
  zoomOut: "Zoom Out",
  zoomIn: "Zoom In",
  layerControl: "Layer Control",

  exportCSV: "Export CSV",
  exportPDF: "Export PDF",
  export: "Export",
  downloadExport: "Download Report",
  changeColumnOrder: "Change column order",
  typeToSearch: "Type to search",
  address: "Address:",
  unit: "Unit:",
  landmark: "Landmark:",
  geofence: "Geofence:",
  unit_value: "Unit",

  custom: "Custom",

  create: "Create",
  daily: "Daily",
  weekly: "Weekly",
  monthly: "Monthly",
  assign: "Assign",

  merge: "Merge",
  map_legend: "Legend",

  //modules
  units: "Units",
  Unit_Groups: "Unit groups",
  drivers: "Drivers",
  driver_groups: "Driver groups",

  filters: "Filters",
  apply: "Apply",
  //map layers
  Hybrid_layer: "Hybrid",
  Map_layer: "Map",
  Satellite_layer: "Satellite",
  Terrain_layer: "Terrain",
  Camera: "Camera",
  allow: "Allow",

  //map fullscreen
  map_fullscreen: "Fullscreen",

  //map traffic
  map_traffic: "Traffic",
  map_weather: "Weather",
  map_radar: "Radar",
  map_satellite: "Satellite",
  map_heat_index: "Heat Index",
  map_forecasted_heat_index: "Forecasted Heat Index",
  map_humidity: "Humidity",
  map_surface_analysis: "Surface Analysis",
  map_drought_monitor: "Drought Monitor",
  map_forecasted_feels_like_temperature: "Forecasted Feels Like Temperature",
  map_forecasted_jet_stream: "Forecasted Jet Stream (250mb)",
  map_forecasted_precipitation: "Forecasted Precipitation (1 Hour)",
  map_forecasted_precipitation_6: "Forecasted Precipitation (6 Hour)",
  map_view_detail: "View Detail...",
  map_live: "LIVE",
  map_animation_zone: "ANIMATION ZONE",
  map_stop_following: "Stop following",
  map_following: "FOLLOWING",

  remove: "Remove",
  untagged: "Untagged",

  on: "On",
  off: "Off",
  email: "Email",
  none: "None",
  selectAll: "Select All",

  exportInProcessTitle: "Exporting...",
  exportInProcessBody:
    "This could take some time, the file will be downloaded automatically when it is ready",
  exportSuccess: "The file has been downloaded successfully",

  loading: "Loading...",
  phone: "Phone",
  contacts: "Contacts",
  emailAddress: "Email Address:",
  phoneNumber: "Phone Number:",
  selectContact: "Select a Contact:",
  add_recipient: "Add Recipient",
  required_email: "Please enter a valid email",
  required_phone: "Please enter a valid phone number",
  select_country_code: "Select a Country:",
  enterEmailAddress: "Enter Email Address",
  enterPhoneNumber: "Enter Phone Number",
  OF: "OF",
  chat: "Chat",
  troubleshooting: "Troubleshooting",
  supportAgent: "support agent",
  unitOverViewPanel: "Vehicle Overview",
  system: "System",
  driverID: "Driver ID",
  vehicle: "Vehicle",
  eventID: "Event ID",
  date: "Date",
  time: "Time",
  notes: "Notes",
  errorCompanyReadOnly:
    "It is not possible to make changes to this entity because the application is in trial mode. Please contact support if you have any questions",

  // Events
  event_all: "All",
  event_drive: "Driving",
  event_ping: "Ping",
  event_travelstartstop: "Travel Start/Stop",
  event_travelstop: "Travel Stop",
  event_travelstart: "Travel Start",
  event_ignitiononoff: "Ignition On/Off",
  event_ignitionoff: "Ignition Off",
  event_ignitionon: "Ignition On",
  event_driveevent: "Driving",
  event_motionevent: "Moving",
  event_totaltime: "Total Time",
  event_overspeed: "Over Speed",
  event_maxspeed_one: "Max Speed",
  event_maxspeed: "Max Speed Recorded",
  event_travelstart: "Travel Start",
  event_motionstart: "Motion Start",
  event_asleep: "Asleep",
  event_auto_snapshot: "Auto Snapshot",
  event_autosnapshot: "Auto Snapshot",
  event_position_update: "Position Update",
  event_camera_obstructed: "Camera Obstructed",
  event_close_following: "Close Following",
  event_collision_warning: "Collision Warning",
  event_comm_acquired: "Comm Acquired",
  event_comm_lost: "Comm Lost",
  event_cyclist_warning: "Cyclist Warning",
  event_data_usage: "Data Usage",
  event_distracted: "Distracted",
  event_drive: "Driving",
  event_drowsiness: "Drowsiness",
  event_face_recognition: "Face Recognition",
  event_hard_brake: "Hard Brake",
  event_hard_turn: "Hard Turn",
  event_heart_beat: "Heartbeat",
  event_idle: "Idle",
  event_idle_no_driver: "Idle No Driver",
  event_ignition_off: "Ignition Off",
  event_ignition_on: "Ignition On",
  event_ignition_off_on: "Ignition On/Ignition Off",
  event_lane_departure: "Lane Departure",
  event_main_power_connect: "Main Power Connect",
  event_main_power_disconnect: "Main Power Disconnect",
  event_maintenancewarning: "Maintenance Warning",
  event_manual: "Manual",
  event_new: "New",
  event_no_seatbelt: "No Seatbelt",
  event_off: "Off",
  event_parked: "Parked",
  event_parking_hit: "Parking Hit",
  event_passenger_inside: "Passenger Inside",
  event_passenger_seatbelt: "Passenger Seatbelt",
  event_pedestrian_detection: "Pedestrian Detection",
  event_periodic_boot: "Periodic Boot",
  event_posted_speed: "Posted Speed",
  event_potential_incident: "Potential Incident",
  event_potential_incident_high: "Potential Incident High",
  event_potential_incident_low: "Potential Incident Low",
  event_potential_incident_medium: "Potential Incident Medium",
  event_power_lost: "Power Lost",
  event_rapid_acceleration: "Rapid Acceleration",
  event_sdcarderror: "SD Card Error",
  event_sdcardstatus: "SD Card Status",
  event_smoking: "Smoking",
  event_speed_threshold: "Speed Threshold",
  event_stop_sign_violation: "Stop Sign Violation",
  event_tailgating: "Tailgating",
  event_test_ng: "Test NG",
  event_travel_start: "Travel Start",
  event_travel_stop: "Travel Stop",
  event_unassigned_driver: "Unassigned Driver",
  event_using_phone: "Using Phone",
  event_yawn: "Yawn",
  event_checking: "Checking",
  event_diagnostic: "Diagnostic",
  event_geofence_in: "Geofence In",
  event_geofence_out: "Geofence Out",
  event_geofence_set: "Geofence Set",
  event_geofence_update: "Geofence Update",
  event_heartbeat_checkin: "Heartbeat Check-in",
  event_input_toggle: "Input Toggle",
  event_internal_battery_connect: "Internal Battery Connect",
  event_low_battery: "Low Battery",
  event_output_1_disabled: "Output 1 Disabled",
  event_output_1_enabled: "Output 1 Enabled",
  event_power_off: "Power Off",
  event_power_up: "Power Up",
  event_script_update: "Script Update",
  event_starter_disable: "Starter Disabled",
  event_starter_enable: "Starter Enabled",
  event_tow: "Tow",
  event_user_update: "User Update",
  event_vehicle_movement: "Vehicle Movement",
  event_idling_end: "Idling End",
  event_speeding_end: "Speeding End",
  event_2_minutes_after_power_on: "2 Minutes after Power On",
  event_absolute_g_wake: "Absolute G Wake",
  event_acceleration: "Acceleration",
  event_agps_start: "AGPS Start",
  event_alarm_armed: "Alarm Armed",
  event_alarm_disarmed: "Alarm Disarmed",
  event_alarm_off: "Alarm Off",
  event_alarm_on: "Alarm On",
  event_battery_connect: "Battery Connect",
  event_battery_threshold: "Battery Threshold",
  event_battery_update: "Battery Update",
  event_boot_checkin: "Boot Check-in",
  event_cell_antenna_connect: "Cell Antenna Connect",
  event_cell_jamming_start: "Cell Jamming Start",
  event_cell_jamming_stop: "Cell Jamming Stop",
  event_change_of_location_area_alert: "Change of Location Area Alert",
  event_check_engine_off: "Check Engine OFF",
  event_check_engine_on: "Check Engine ON",
  event_cluster: "Cluster",
  event_cold_boot: "Cold Boot",
  event_comm_reset: "Comm Reset",
  event_comm_reset_by_command: "Comm Reset by Command",
  event_comm_reset_no_ack: "Comm Reset No ACK",
  event_comm_reset_no_at: "Comm Reset No AT",
  event_consistent_speed: "Consistent Speed",
  event_crash: "Crash",
  event_deceleration: "Deceleration",
  event_device_info: "Device Info",
  event_device_turned_on: "Device Turned On",
  event_disabled: "Disabled",
  event_door_ajar: "Door Ajar",
  event_door_lock: "Door Lock",
  event_door_unlock: "Door Unlock",
  event_driver_login: "Driver Login",
  event_driver_logout: "Driver Logout",
  event_dtc_event: "DTC Event",
  event_emergency: "Emergency",
  event_emergency_end: "Emergency End",
  event_engine_code: "Engine Code",
  event_engine_off: "Engine Off",
  event_engine_on: "Engine On",
  event_engine_on_minutes_report: "Engine On Minutes Report",
  event_engineering_message: "Engineering Message",
  event_firmware_update: "Firmware Update",
  event_fuel_loss_detected: "Fuel Loss Detected",
  event_fuel_refill_detected: "Fuel Refill Detected",
  event_gps_acquired: "GPS Acquired",
  event_gps_antenna_connect: "GPS Antenna Connect",
  event_gps_antenna_disconnect: "GPS Antenna Disconnect",
  event_gps_jamming_start: "GPS Jamming Start",
  event_gps_jamming_stop: "GPS Jamming Stop",
  event_gps_not_available: "GPS Not Available",
  event_gps_position: "GPS Position",
  event_gps_reset: "GPS Reset",
  event_hard_stop: "Hard Stop",
  event_heading_change: "Heading Change",
  event_idling: "Idling",
  event_input_1_off: "Input 1 Off",
  event_input_1_on: "Input 1 On",
  event_input_2_off: "Input 2 Off",
  event_input_2_on: "Input 2 On",
  event_input_3_off: "Input 3 Off",
  event_input_3_on: "Input 3 On",
  event_input_4_off: "Input 4 Off",
  event_input_4_on: "Input 4 On",
  event_input_5_off: "Input 5 Off",
  event_input_5_on: "Input 5 On",
  event_input_6_off: "Input 6 Off",
  event_input_6_on: "Input 6 On",
  event_input_7_off: "Input 7 Off",
  event_input_7_on: "Input 7 On",
  event_input_status_changed: "Input Status Changed",
  event_install_sensor: "Install Sensor",
  event_internal_battery_disconnect: "Internal Battery Disconnect",
  event_internal_battery_recovered: "Internal Battery Recovered",
  event_live: "Live",
  event_locate: "Locate",
  event_location: "Location",
  event_location_report: "Location Report",
  event_long_engine_idle: "Long Engine Idle",
  event_loss_of_gps_fix: "Loss of GPS Fix",
  event_low_internal_battery: "Low Internal Battery",
  event_main_power_on: "Main Power On",
  event_maintenance_limit_exceeded: "Maintenance Limit Exceeded",
  event_message: "Message",
  event_minor: "Minor",
  event_motion: "Motion",
  event_motion_stop: "Motion Stop",
  event_no_gps: "No GPS",
  event_normal: "Normal",
  event_obdii_message: "OBDII Message",
  event_oem_speeding: "OEM Speeding",
  event_operator_alarm: "Operator Alarm",
  event_output_2_disabled: "Output 2 Disabled",
  event_output_2_enabled: "Output 2 Enabled",
  event_paged: "Paged",
  event_power_down: "Power Down",
  event_power_down_stop: "Power Down Stop",
  event_power_on: "Power On",
  event_power_protect: "Power Protect",
  event_recentering: "Recentering",
  event_restart: "Restart",
  event_rfid: "RFID",
  event_rollover: "Rollover",
  event_rpm_threshold: "RPM Threshold",
  event_satellite_off: "Satellite Off",
  event_satellite_on: "Satellite On",
  event_satellite_update: "Satellite Update",
  event_sleep: "Sleep",
  event_sms: "SMS",
  event_stand_by: "Stand By",
  event_status_update: "Status Update",
  event_stop: "Stop",
  event_tamper_alarm: "Tamper Alarm",
  event_temp_trip: "Temp Trip",
  event_temp_1_over_high: "Temp-1 Over High",
  event_temp_1_under_low: "Temp-1 Under Low",
  event_temp_2_over_high: "Temp-2 Over High",
  event_temp_2_under_low: "Temp-2 Under Low",
  event_temp_3_over_high: "Temp-3 Over High",
  event_temp_3_under_low: "Temp-3 Under Low",
  event_temperature: "Temperature",
  event_time: "Time",
  event_tow_end: "Tow End",
  event_turn: "Turn",
  event_undesired_input: "Undesired Input",
  event_unknown: "Unknown",
  event_update: "Update",
  event_update_boot: "Update Boot",
  event_vehicle_detect: "Vehicle Detect",
  event_vibration_wake: "Vibration Wake",
  event_vin: "VIN",
  event_virtual_ignition_off: "Virtual Ignition Off",
  event_virtual_ignition_on: "Virtual Ignition On",
  event_voltage_wake: "Voltage Wake",
  event_wakeup: "Wakeup",
  event_wakeup_periodic: "Wakeup Periodic",
  event_warm_boot: "Warm Boot",
  event_watchdog: "Watchdog",
  event_light_sensor_alarm: "Light Sensor Alarm",
  event_sudden_stop: "Sudden Stop",
  event_trip_ongoing: "Trip Ongoing",
  event_overfill: "Overfill",
  event_clock_in: "Clock In",
  event_clock_out: "Clock Out",
  event_meal_break_begin: "Meal Break Begin",
  event_meal_break_end: "Meal Break End",

  // assets tab

  asset_tab_label: "Label",
  asset_tab_assetType: "Asset Type",
  asset_tab_assetSubtype: "Asset SubType",
  asset_tab_licensePlate: "License Plate",
  asset_tab_registrationCountry: "Registration Country",
  asset_tab_registrationState: "Registration State",
  asset_tab_registrationExpiration: "Registration Expiration Date",
  asset_tab_vin: "VIN",
  asset_tab_make: "Make",
  asset_tab_model: "Model",
  asset_tab_year: "Year",
  asset_tab_engineLiters: "Engine Liters",
  asset_tab_highway: "Highway",
  asset_tab_city: "City",
  asset_tab_inspectionTagId: "Inspection Tag ID",
  asset_tab_asset: "Asset",
  asset_tab_tag: "Tag",
  asset_tab_tags: "Tags",
  asset_tab_powerUnitNumber: "Power Unit Number",
  asset_tab_decodeVIN: "Decode VIN",
  asset_tab_inspectionDeviceType: "Inspection Device Type",
  asset_tab_noInformationFoundVIN: "No information found for this VIN",
  asset_tab_maxValue: "Max value",
  asset_tab_minValue: "Min value",
  asset_tab_externalId: "External ID",
  asset_tab_createAsset: "Create New Asset",
  asset_tab_assetSaved: "Asset saved",
  asset_tab_maintenance: "Maintenance",
  asset_tab_maintenanceCompany: "Maintenance Company",
  asset_tab_inServiceDate: "In Service Date",
  asset_tab_registration: "Registration",
  asset_tab_chassisSerialNumber: "Chassis Serial Number",
  asset_tab_engineSerialNumber: "Engine Serial Number",
  asset_tab_vehicleId: "Vehicle ID",
  asset_tab_mpg: "MPG",
  asset_tab_evir: "EVIR",
  asset_tab_zonarEld: "Zonar ELD",

  driver_performance_driver_timeInfo_message: "Driver groupings are generated daily in UTC (Server Time), so you may see records from the previous or next day depending on your time zone.",
};

let videoEvents = {
  Asleep: "Asleep",
  "Camera Obstructed": "Camera Obstructed",
  "Close Following": "Close Following",
  "Collision Warning": "Collision Warning",
  "Cyclist Warning": "Cyclist Warning",
  'Travel Start': "Travel Start",
  "AutoSnapshot": "AutoSnapshot",
  "Drive": "Drive",
  Distracted: "Distracted",
  Drowsiness: "Drowsiness",
  "Hard Brake": "Hard Brake",
  "Hard Turn": "Hard Turn",
  "Idle No Driver": "Idle No Driver",
  "Lane Departure": "Lane Departure",
  "Main Power Disconnect": "Main Power Disconnect",
  Manual: "Manual",
  "No Seatbelt": "No Seatbelt",
  "Passenger Inside": "Passenger Inside",
  "Passenger Seatbelt": "Passenger Seatbelt",
  "Pedestrian Detection": "Pedestrian Detection",
  "Posted Speed": "Posted Speed",
  "Potential Incident": "Potential Incident",
  "Rapid Acceleration": "Rapid Acceleration",
  Smoking: "Smoking",
  "Speed Threshold": "Speed Threshold",
  "Rolling Stop Sign": "Rolling Stop Sign",
  "Distracted / Using Phone": "Distracted / Using Phone",
  "Stop Sign Violation": "Stop Sign Violation",
  Tailgating: "Tailgating",
  "Using Phone": "Using Phone",
  Yawn: "Yawn",
  "Day Dreaming": "Day Dreaming",
  "Parking Hit": "Parking Hit",
  Drowsy: "Drowsy",
  "Sudden Stop": "Sudden Stop",
  Parking: "Parking",
  AutoSnapshot: "AutoSnapshot",
  "Potential Incident Low": "Potential Incident Low",
  "Potential Incident Medium": "Potential Incident Medium",
  "Potential Incident High": "Potential Incident High",
  single_unit: "Single Unit",
  single_driver: "Single Driver",
  tags: "Tags",
  all_units: "All Units",
  all_drivers: "All Drivers",
  allUnitSelected: "All units selected",
  allDriverSelected: "All drivers selected",
  selectUnitsOrSearchByName: "Select units or search by name",
  selectDriversOrSearchByName: "Select drivers or search by name",
  selectTags: "Select tags",
  selectAllTags: "Select all tags",
  inactive: "Inactive",
  active: "Active",
  allForm: "All Forms",
  searchTags: "Search tags",
  includeInactiveDrivers: "Include Inactive drivers",
  includeUnassignedDrivers: "Include Unassigned drivers",
  filterEventsMap_buttonLabel: "Filters",
};

//Merge Modules
import alerts from "Modules/alerts/.globals/lan/en";
import behavior from "Modules/behavior/.globals/lan/en";
import fleet from "Modules/fleet/.globals/lan/en";
import maintenance from "Modules/maintenance/.globals/lan/en";
import reports from "Modules/reports/.globals/lan/en";
import security from "Core/.globals/lan/en";
import realtimeMaps from "Modules/realtimeMaps/.globals/lan/en";
import common from "Modules/.common/.globals/lan/en";
import video from "Modules/video/.globals/lan/en";
import account from "Modules/account/.globals/lan/en";
import settings from "Modules/settings/.globals/lan/en"; //! Remove old settings module progressively
import manage from "Modules/manage/.globals/lan/en";
import dashboard from "Modules/dashboard/.globals/lan/en";
import fsm from "Modules/fsm/.globals/lan/en";
import { gtc_locales_en } from "@gpstrackit/gtc-react-controls";
import dynamicForms from "Modules/dynamicForms/.globals/lan/en";
import chat from "../../../modules/chat/.globals/lan/en";
import routes from "../../../modules/routes/.globals/lan/en";
import incidents from "Modules/incidents/.globals/lan/en";
import workOrders from "Modules/workOrders/.globals/lan/en";
import integrations from "Modules/integrations/.globals/lan/en";
import template from "Modules/.template/.globals/lan/en";
import driver from "Modules/driver/views/driverTable/lan/en";

locales = {
  ...alerts,
  ...behavior,
  ...fleet,
  ...locales,
  ...maintenance,
  ...reports,
  ...security,
  ...realtimeMaps,
  ...common,
  ...video,
  ...account,
  ...fsm,
  ...settings,
  ...manage,
  ...dashboard,
  ...gtc_locales_en,
  ...dynamicForms,
  ...chat,
  ...routes,
  ...incidents,
  ...videoEvents,
  ...workOrders,
  ...integrations,
  ...template,
  ...driver,
};

export default locales;
